/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon16Light = forwardRef('NumberCircle07Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.69 4.01H5.176v.837H9.56a19.26 19.26 0 0 0-1.977 3.435c-.58 1.273-.95 2.513-1.108 3.718H7.56c.173-1.288.55-2.576 1.13-3.865.588-1.295 1.254-2.43 2-3.4V4.01Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.004a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-6 7a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" })));
});
